/**
 * 七牛云图片缩略图工具
 *
 * 列表里的小图标（32~60px）如果直接用原图，代价极大：
 *   - 原图普遍是 1278×1278，解码后占内存 1278*1278*4 ≈ 6.5MB/张，
 *     出入库统计页有近百个商品 → 约 640MB 位图，浏览器打开即卡死；
 *   - 流量也白白多出几十倍（原图 ~360KB vs 缩略图 ~9KB）。
 *
 * 统一走七牛 imageView2 处理参数，只取实际需要的宽度。
 *
 * ⚠️ hover / 点击弹出的大图预览必须继续使用原图，不要套这个函数。
 */
export function thumbUrl(url, width = 200) {
  if (!url || typeof url !== 'string') return url
  // 非远程地址（blob:/data:/相对路径）不处理
  if (!/^https?:\/\//i.test(url)) return url
  // 已带处理参数的不重复追加
  if (url.includes('?')) return url
  return `${url}?imageView2/2/w/${width}`
}

export default thumbUrl
